import 'fontsource-hepta-slab'
import 'fontsource-work-sans'
import 'victormono'
import { wrapPageElement as wrap } from '../src/woot-wapper'

export const wrapPageElement = wrap
